import { render } from "./new-50-img.vue?vue&type=template&id=17451978&scoped=true&lang=html"
import script from "./new-50-img.vue?vue&type=script&lang=js"
export * from "./new-50-img.vue?vue&type=script&lang=js"

import "./new-50-img.vue?vue&type=style&index=0&id=17451978&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17451978"]])

export default __exports__